const styles = {
  dropdownContainer: {
    boxShadow: (t) => t.boxShadows.dragAndDrop,
    backgroundColor: (t) => t.palette.common.white
  },
  footer: {},
  header: {},
  ddContent: {
    backgroundColor: (t) => t.palette.common.white
  }
};
export {
  styles
};
//# sourceMappingURL=sharedStyles.js.map
